function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 10.04 10.04",
    style: {
      enableBackground: "new 0 0 10.04 10.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M2.897,6.477c-0.024,0-0.049-0.003-0.073-0.008C2.679,6.435,2.577,6.306,2.578,6.158l0.001-0.53 c0-2.229,1.813-4.042,4.043-4.042h0.134V0.441c0-0.128,0.077-0.244,0.195-0.294c0.117-0.051,0.255-0.024,0.346,0.065l2.647,2.582 c0.061,0.06,0.097,0.141,0.097,0.226c0.001,0.085-0.033,0.167-0.093,0.228L7.299,5.895c-0.092,0.092-0.231,0.117-0.348,0.07 C6.833,5.915,6.755,5.799,6.755,5.67V4.415H6.231c-1.299,0-2.467,0.723-3.048,1.886C3.127,6.411,3.016,6.477,2.897,6.477z  M6.621,2.224c-1.688,0-3.092,1.235-3.359,2.847c0.753-0.817,1.817-1.294,2.969-1.294h0.844c0.177,0,0.319,0.143,0.319,0.319 v0.803l1.874-1.874L7.393,1.198v0.707c0,0.176-0.142,0.319-0.319,0.319H6.621z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#424242"
    },
    d: "M8.771,9.919H1.269C0.569,9.919,0,9.349,0,8.649V2.855c0-0.7,0.569-1.269,1.269-1.269h0.316 c0.176,0,0.319,0.143,0.319,0.319S1.761,2.224,1.585,2.224H1.269c-0.348,0-0.631,0.283-0.631,0.631v5.794 c0,0.348,0.283,0.632,0.631,0.632h7.502c0.348,0,0.632-0.284,0.632-0.632V6.403c0-0.176,0.142-0.319,0.319-0.319 c0.177,0,0.319,0.143,0.319,0.319v2.246C10.04,9.349,9.471,9.919,8.771,9.919z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.0b80d0ad.svg";
export { ForwardRef as ReactComponent };